const initialState = {
  image: {},
  pages: [],
  overlays: []
}

const BackgroundReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_BACKGROUND':
      return Object.assign({}, {
        ...state,
        image: action.value.bg,
        pages: action.value.nav ? action.value.nav[0].subpages : undefined,
        overlays: action.value.overlays
      })
    case 'UPDATE_OBJECTS':
      return Object.assign({}, {
        ...state,
        overlays: action.value
      })
    default:
      return state
  }
}

export default BackgroundReducer
